import { PaymentMethodsEntity } from 'gb-dashboard/setup/data-access-payment-methods'
import { LoaderTypeEnum } from 'libs/shared/utils/loader/src/lib/+state/loader.models'
import { PaymentIntent } from '@stripe/stripe-js'

export interface StripeEntity {
  id: string | number
  name: string
}

export interface AttachPaymentMethodResponse {
  payment_methods: PaymentMethodsEntity[]
  stripe_connect: string
  stripe_customer_id: string
  user: string
}

export const STRIPE_LOADER = {
  prepareCardForSetup: {
    id: 'prepareCardForSetup',
    type: LoaderTypeEnum.Dialog,
  },
  addCard: {
    id: 'addCard',
    type: LoaderTypeEnum.Dialog,
  },
}
